/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedCategoryTilesTracking_itemSearch$ref = any;
export type SbRespCategoryTiles_itemSearch$ref = any;
export type SbRespCategoryTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly categoryTiles: ReadonlyArray<{
        readonly displayName: string | null;
        readonly rank: number | null;
        readonly url: string | null;
        readonly image: string | null;
        readonly masterImage: string | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedCategoryTilesTracking_itemSearch$ref;
    readonly " $refType": SbRespCategoryTiles_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCategoryTiles_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "categoryTiles",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseCategoryTiles",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "rank",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "image",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "masterImage",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedCategoryTilesTracking_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '08906dc1ec1f9d5b67ca55ae05c2a6f3';
export default node;
